import { render } from "./Tag.vue?vue&type=template&id=4c05dac6&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=4c05dac6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c05dac6"]])

export default __exports__